import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import userAPI from '../../services/userAPI';
import logo from '../../assets/waseeny-logo.png';
import { formatMoney } from '../../utils/formatMoney';
import NotificationBell from '../Common/NotificationBell';
import './Profile.css';

const Wallet = () => {
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchWallet();
  }, []);

  const fetchWallet = async () => {
    try {
      setLoading(true);
      const data = await userAPI.getWallet();
      setWallet(data);
    } catch (err) {
      console.error('Failed to fetch wallet:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="profile-page">
      <header className="profile-header-bar">
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <button className="back-btn" onClick={() => navigate(-1)}>
             <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
          </button>
          <h1>My Wallet</h1>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <NotificationBell />
          <img src={logo} alt="Logo" style={{ height: '30px' }} />
        </div>
      </header>

      <div className="profile-container">
        <div className="profile-card" style={{ textAlign: 'center' }}>
          {loading ? (
            <div className="animate-pulse space-y-3 py-4 flex flex-col items-center">
              <div className="h-4 w-28 bg-gray-200 rounded mx-auto"></div>
              <div className="h-8 w-44 bg-gray-200 rounded mx-auto"></div>
              <div className="h-10 w-32 bg-gray-200 rounded-full mx-auto"></div>
            </div>
          ) : (
            <>
              <span className="balance-label">Current Balance</span>
              <h2 className="balance-amount">{formatMoney(wallet?.balance, { symbol: wallet?.currencySymbol || '' })}</h2>
              <button 
                className="add-money-btn"
                onClick={() => alert('Add money feature coming soon!')}
              >
                + Add Money
              </button>
            </>
          )}
        </div>

        <h2 style={{ fontSize: '18px', margin: '32px 0 16px', fontWeight: '700' }}>Transaction History</h2>
        
        <div className="profile-card">
          {loading ? (
            <div className="animate-pulse space-y-3 p-2">
              {[1, 2, 3].map((i) => (
                <div key={i} className="flex justify-between items-center py-3 border-b border-gray-100">
                  <div className="space-y-2">
                    <div className="h-4 w-36 bg-gray-200 rounded"></div>
                    <div className="h-3 w-24 bg-gray-200 rounded"></div>
                  </div>
                  <div className="h-5 w-16 bg-gray-200 rounded"></div>
                </div>
              ))}
            </div>
          ) : !wallet?.transactions || wallet.transactions.length === 0 ? (

            <div style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{ fontSize: '40px', marginBottom: '10px' }}>📄</div>
                <p style={{ color: '#888' }}>No transactions yet</p>
            </div>
          ) : (
            <div className="transaction-list">
              {wallet.transactions.map((tx, idx) => (
                <div key={idx} className="transaction-item">
                  <div className="tx-info">
                    <div className="tx-description">{tx.description}</div>
                    <div className="tx-date">{new Date(tx.createdAt).toLocaleString()}</div>
                  </div>
                  <div className={`tx-amount ${tx.type}`}>
                    {tx.type === 'credit' ? '+' : '-'} {formatMoney(tx.amount, { symbol: wallet?.currencySymbol || '' })}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Wallet;
